// /src/api/config/axiosConfig.js
import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

// Axios instance with custom configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically inject Authorization token from localStorage on every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('shelLoginToken');
    if (token) {
      config.headers = config.headers || {};
      const currentAuth = config.headers.Authorization || config.headers.authorization;
      if (!currentAuth || currentAuth === 'Bearer null' || currentAuth === 'Bearer undefined' || currentAuth === 'Bearer ') {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: graceful handling of 401s (expired session)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      console.warn('[Axios] 401 Unauthorized: Session token expired or invalid.');
      const path = window.location.pathname;
      if (path !== '/' && path !== '/login' && path !== '/signin') {
        localStorage.removeItem('shelLoginToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
